import React from 'react';

export default function FeaturedList({ coopArticle }) {
  return (
    <>
      {coopArticle.length > 0 && (
        <>
          <div data-card-size="large" className="grid card__grid">
            {coopArticle &&
              coopArticle.map((i) => (
                <div className="grid__col-lg-6 grid__col-xs-12">
                  <article key={i.id} className="card">
                    <a href={i.url}>
                      <img
                        src={i.image}
                        className="card__media"
                        alt={i.title}
                      />
                      <section className="card__body card__body--large">
                        <p className="card__category">{i.kicker}</p>
                        <h4
                          className="card__title"
                          dangerouslySetInnerHTML={{ __html: i.title }}
                        ></h4>
                        <p className="card__description">{i.subheader}</p>
                      </section>
                    </a>
                    <hr className="card__hr" />
                  </article>
                </div>
              ))}
          </div>
          <hr className="section__hr" />
        </>
      )}
    </>
  );
}
